import dataType from './dataType'
import reportStatus from './reportStatus'
import status from './status'
import messageAlert from './messageAlert'

const auditProcess = {
  dataType,
  reportStatus,
  status,
  messageAlert,
}

export default auditProcess
